import { useEffect } from "react";
import { usePropertyMap } from "@/api/hooks";
import { staticMapUrlWithoutMarkers } from "@/utils/solarLayoutOverlay";

export default function PropertyAerial({ address, postcode }: { address: string; postcode: string }) {
  const { mutate, data, isPending, isError } = usePropertyMap();

  useEffect(() => {
    const trimmedAddress = address.trim();
    const trimmedPostcode = postcode.trim();
    if (!trimmedAddress || !trimmedPostcode) return;
    mutate({ address: trimmedAddress, postcode: trimmedPostcode });
  }, [address, postcode, mutate]);

  const photoUrl = data?.satelliteImage?.url ? staticMapUrlWithoutMarkers(data.satelliteImage.url) : "";

  if (isError || (!isPending && !photoUrl)) return null;

  return (
    <div className="relative overflow-hidden rounded-2xl border border-border bg-cream">
      {photoUrl ? (
        <>
          <img src={photoUrl} alt="Aerial view of your property" className="h-52 w-full object-cover sm:h-64" />
          <img
            src="/powlo-mark-lime.svg"
            alt=""
            className="pointer-events-none absolute left-1/2 top-1/2 h-9 w-9 -translate-x-1/2 -translate-y-[85%] drop-shadow-[0_2px_4px_rgba(12,13,16,0.45)]"
          />
        </>
      ) : (
        <div className="flex h-52 items-center justify-center text-sm text-muted sm:h-64">Loading aerial view…</div>
      )}
    </div>
  );
}
